import React from "react";
import { ConfigProvider } from "antd";
import "react-app-polyfill/stable";
import "antd-mobile/dist/antd-mobile.css";
import ReactDOM from "react-dom";
import "./index.css";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { store, persistor } from "@src/redux/store";
import * as serviceWorker from "./serviceWorker";
// Lang
import jaJP from "antd/lib/locale/ja_JP";
import moment from "moment";
import "moment/locale/ja";
import { PersistGate } from "redux-persist/integration/react";
import AppRoutes from "./AppRoutes";

moment.locale("ja_JP");
moment.updateLocale("ja", {
  week: {
    dow: 1, //set monday as the first day of week
  },
});
jaJP.Empty.description = "データがありません。";

ReactDOM.render(
  <BrowserRouter>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ConfigProvider locale={jaJP}>
          <AppRoutes />
        </ConfigProvider>
      </PersistGate>
    </Provider>
  </BrowserRouter>,
  document.getElementById("root")
);

serviceWorker.register();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
